import React from 'react';
import { Edit, SimpleForm, TextInput } from 'react-admin';

export const CategoryEdit = () => (
    <Edit title="Edit category" actions={false} redirect="list">
      <SimpleForm>
        <TextInput source="name" label="Name" required />
        <TextInput source="description" label="Description" required />
      </SimpleForm>
    </Edit>
);

